






























import Vue from 'vue';
import { mapActions } from 'vuex'
import defaulter from '@/modules/defaulter'
import phonenumber from '@/modules/phonenumber'

export default Vue.extend({
  name: 'CustomerModal',
  data () {
    return {
      modal: {
        title: "Customer",
      },
      emptyCustomerForm: {
        id:           null,
        name:         '',
        phone_number: '',
        bank_id:      null,
        authorized:   true
      },
      customerForm: {
        id:           null,
        name:         '',
        phone_number: '',
        bank_id:      null,
        authorized:   true
      },
      showingConfirmDeleteButton: false
    }
  },
  methods: {
    ...mapActions([
      'getCustomer',
      'addOrUpdateCustomer',
    ]),

    handleModalOk (bvModalEvent) {
      bvModalEvent.preventDefault()
      this.submitForm()
    },

    async loadCustomer (customerId: number) {
      const response = await this.getCustomer(customerId)
      if (response.success) {
        if (response.customer.phone_number) {
          response.customer.phone_number = phonenumber.parsePhoneNumber(response.customer.phone_number).formatted
        }
        this.customerForm = defaulter.merge(this.emptyCustomerForm, response.customer)
      }
    },

    show (customer?: Customer) {
      if (customer) {
        this.customerForm = defaulter.merge(this.emptyCustomerForm, customer)
      }
      this.showingConfirmDeleteButton = false
      this.$refs.modal.show()
    },

    hide () {
      this.$refs.modal.hide()
    },

    async loadAndShow (customer: Customer) {
      if (customer) {
        await this.loadCustomer(customer.id)
        this.showingConfirmDeleteButton = false
        this.$refs.modal.show()
      }
    },

    async submitForm () {
      if (!this.customerForm.name) {
        this.$refs.nameInput.focus()
        return
      }
      if (!this.customerForm.phone_number) {
        this.$refs.phoneNumberInput.focus()
        return
      }
      const result = await this.addOrUpdateCustomer(this.customerForm)
      this.done(result)
    },

    confirmDeleteCustomer () {
      this.showingConfirmDeleteButton = true
    },

    async deleteCustomer () {
      const result = await this.$store.dispatch('deleteCustomer', this.customerForm)
      this.done(result)
    },

    done (result: Result) {
      if (result.success) {
        this.$bvToast.toast(result.message, {
          title: 'Success',
          toaster: 'b-toaster-bottom-right',
          variant: 'success',
          autoHideDelay: 3000
        })
        this.$emit('change')
        this.hide();
      } else {
        this.$bvToast.toast(result.message, {
          title: 'Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 6000
        })
      }
    },

    parsePhoneNumber (phone, event) {
      let parsed = phonenumber.parsePhoneNumber(phone)
      this.$set(this.customerForm, 'phone_number', parsed.formatted)
      event.target.focus();
      event.target.setSelectionRange(parsed.formatted.length, parsed.formatted.length);
    },

  }
})
